import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-form-message',
  styleUrls: ['form-message.component.scss'],
  template: `
    @if (props.label) {
      <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
      <label
        class="section col-12 {{ props.messageType }}"
        tabindex="0"
        [innerHTML]="props.label"
      ></label>
    }
  `,
  imports: [CommonModule],
})
export class FormlyMessageComponent extends FieldType {}
